import React, { Component } from 'react';
import CrcCalculator from '../crc-calculator/CrcCalculator';
import './CrcContainer.css';
import CrcHeader from '../crc-header/CrcHeader';
import CrcFooter from '../crc-footer/CrcFooter';

export class CrcContainer extends Component {
  render() {
    return (
      <div>
        <CrcHeader />
        <div className="crc-container">
          <div className="crc-container-center">
            <h1>Heart Activity Calculator</h1>
            <p>Welcome to Cleveland Clinic’s Preventive Cardiology and Rehabilitation Heart Activity Calculator. Keeping active is essential for a healthy heart, but it’s hard to know what activities to choose, just how much is needed and what all of your actions can mean for you. This calculator can help. Explore the calculator, use it every day, try some new activities and make daily exercise part of your heart-healthy life!</p>
            <CrcCalculator />
          </div>
        </div>
        <CrcFooter />
      </div>
    );
  }
}

export default CrcContainer;



// WEBPACK FOOTER //
// ./src/crc/components/crc-container/CrcContainer.js